// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("./common/Env.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Nextjs = require("@sentry/nextjs");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function errorLevelToJs(level) {
  return level;
}

function addBreadcrumb(message, level, category) {
  Nextjs.addBreadcrumb({
    message: message,
    category: category,
    level: Stdlib_Option.map(level, errorLevelToJs)
  });
}

function captureException(exn, file, line, extra, param) {
  if (Env.node_env === "development") {
    console.log("Sentry.captureException", {
      exn: exn,
      extra: extra,
      file: file,
      line: line
    });
  }
  Nextjs.withScope(scope => {
    if (extra !== undefined) {
      scope.setExtra("extra", Primitive_option.valFromOption(extra));
    }
    scope.setTag("file", file);
    if (line !== undefined) {
      scope.setTag("line", line.toString());
    }
    Nextjs.captureException(exn);
  });
}

function captureErrorMessage(message, userFacing, decoder, file, line, extra, levelOpt, param) {
  let level = levelOpt !== undefined ? levelOpt : "error";
  if (Env.node_env === "development") {
    console.log("Sentry.captureErrorMessage", {
      message: message,
      userFacing: userFacing,
      file: file,
      line: line,
      decoder: decoder,
      extra: extra,
      level: level
    });
  }
  Nextjs.withScope(scope => {
    if (extra !== undefined) {
      scope.setExtra("extra", Primitive_option.valFromOption(extra));
    }
    if (decoder !== undefined) {
      if (decoder) {
        scope.setTag("decoder-error", "true");
      } else {
        scope.setTag("decoder-error", "false");
      }
    }
    scope.setTag("user-facing", userFacing ? "true" : "false");
    scope.setTag("file", file);
    scope.setTag("line", line.toString());
    Nextjs.captureMessage(message, level);
  });
}

exports.errorLevelToJs = errorLevelToJs;
exports.addBreadcrumb = addBreadcrumb;
exports.captureException = captureException;
exports.captureErrorMessage = captureErrorMessage;
/* Env Not a pure module */
